(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-newsletter-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jk-newsletter-form')) {
    customElements.define(
      'jk-newsletter-form',
      class JKNewsletterForm extends HTMLElement {
        constructor() {
          super();
          this.onSubmit = this.onSubmit.bind(this);
          this.onFocus = this.onFocus.bind(this);
        }
        connectedCallback() {
          this.errorTemplate = this.querySelector('[data-error]');
          this.$form = this.querySelector('form');
          this.$form.addEventListener('submit', this.onSubmit);
          this.$form.addEventListener('focusin', this.onFocus);
        }

        disconnectedCallback() {
          this.$form.removeEventListener('submit', this.onSubmit);
          this.$form.removeEventListener('focusin', this.onFocus);
        }

        onFocus() {
          this.$form.removeEventListener('focusin', this.onFocus);
          if (window.Shopify?.captcha?.protect) {
            window.Shopify.captcha.protect(this.$form);
            this.$form.submit = this.onSubmit;
            this.$form.removeEventListener('submit', this.onSubmit);
          } else {
            this.$form.querySelector('input[name="form_type"]').remove();
          }
        }

        async onSubmit(evt) {
          evt?.preventDefault();
          if (this.status === 'loading') return;

          const submitter = this.$form.querySelector('button[type="submit"');
          submitter.classList.add('loading');
          submitter.disabled = true;
          const formData = new FormData(this.$form);
          try {
            const response = await fetch(this.$form.action, {
              method: 'POST',
              body: formData,
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });
            if (response.ok) {
              const text = await response.text();
              this.$form.innerHTML = text;
            } else if (response.status === 400) {
              const data = await response.json();
              if (data?.field) {
                data.error = {};
                if (data.field === 'email') {
                  data.error.email = 'Email is invalid';
                } else if (data.field === 'phone') {
                  data.error.phone = 'Phone number is invalid';
                } else {
                  data.error.all = 'Invalid request, please try again';
                }
              }
              if (data?.error || data?.fieldErrors) {
                const errors = data.error ?? data.fieldErrors;
                this.displayError(`<ul style="margin-right:15px;padding-inline-start:20px;">
            ${Object.entries(errors)
              .map((err) => `<li>${err[1]}</li>`)
              .join('')}
            </ul>
            `);
              } else {
                this.displayError('Error submitting form, please try again');
              }
            } else {
              throw new Error(`Submission error with status ${response.status}`);
            }
          } catch (err) {
            console.error('Error in newsletter submission', err);
            this.displayError('Error submitting form, please try again');
          } finally {
            submitter.classList.remove('loading');
            this.status = 'idle';
          }
        }

        displayError(message) {
          let errorBlock = this.$form.querySelector('.form__error');
          if (!errorBlock) {
            errorBlock = this.errorTemplate.content.cloneNode(true).firstElementChild;
            this.$form.insertBefore(errorBlock, this.$form.querySelector('.newsletter-form__field-wrapper'));
          }
          errorBlock.querySelector('.error-text').innerHTML = message;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
